import * as React from "react";
// import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import apiClient from "../../../utils/api";
import { Checkbox, FormControlLabel } from "@mui/material";

export const AddNewClass: React.FC = () => {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  // const navigate = useNavigate();
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      className: data.get("class-name"),
      professorName: data.get("professor-name"),
      professorEmail: data.get("professor-email"),
      defaultClass: data.get("default-class"),
    });
    // post the data
    apiClient
      .classControllerAdd({
        classAddRequest: {
          classDetails: {
            className: data.get("class-name") as string,
            professorName: data.get("professor-name") as string,
            professorEmail: data.get("professor-email") as string,
            defaultClass: data.get("default-class") === "on",
          },
          professorId: data.get("professor-email") as string
        },
      })
      .then(
        () => {
          // Show the snackbar
          setOpenSnackbar(true);

          // TODO: should close the current page
          // TODO: should redirect to the admin page after min(2s, time to insert into do db) seconds or another format
          setTimeout(() => {
            // navigate("/admin");
            window.close();
          }, 2000);
        },
        (error) => console.error("Error adding new class", error)
      );
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <div>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Add New Class Info Below
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="class-name"
              label="Class Name"
              name="class-name"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="professor-name"
              label="Professor's Name"
              id="password"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="professor-email"
              label="Professor's Email"
              id="professor-email"
            />
            <FormControlLabel
              control={<Checkbox />}
              id="default-class"
              name="default-class"
              label="Make this class the Default Class?"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Add Class
            </Button>
          </Box>
        </Box>
      </Container>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity="success"
        >
          New class added successfully!
        </MuiAlert>
      </Snackbar>
    </div>
  );
};
